import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c14cdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col max-w-sm" }
const _hoisted_2 = { class: "uppercase text-gray-700 text-xs font-bold pb-2" }
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choose..", -1 /* HOISTED */))
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1 /* TEXT */),
    _createElementVNode("select", {
      id: _ctx.elementId,
      class: "block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
      value: _ctx.displayValue.itemName,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSelection && _ctx.updateSelection(...args)))
    }, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (o, i) => {
        return (_openBlock(), _createElementBlock("option", {
          key: i,
          value: o.itemName
        }, _toDisplayString(o.itemName), 9 /* TEXT, PROPS */, _hoisted_5))
      }), 128 /* KEYED_FRAGMENT */))
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3)
  ]))
}